// src/lib/time/constants.ts
/** Nymbl's working calendar. Server-side "today" (period ended, date after this week) uses it. */
export const TIME_ZONE = "America/New_York";

/** Expected hours in a week for the cards and the Missing number (TE-36: fixed 40). */
export const WEEK_HOURS = 40;

/** One entry is 0.25 to 24 hours in quarter-hour steps (spec rule 11). */
export const MIN_ENTRY_HOURS = 0.25;
export const MAX_ENTRY_HOURS = 24;

/**
 * An entry of this many hours or more needs a comment, on any task (TE-32; inclusive as Vinyl
 * enforced it, DECISIONS 2026-10-26; widened from billable-only, DECISIONS 2026-10-28).
 */
export const COMMENT_REQUIRED_FROM_HOURS = 2;

/** Log time quick-set buttons: 15m, 30m, 1h, 2h, 4h, 8h (DECISIONS 2026-10-15). */
export const QUICK_HOURS: readonly number[] = [0.25, 0.5, 1, 2, 4, 8];

/** A week's sign-off is late after this local time on the Monday after the week ends (Zack, 2026-10-15). */
export const SIGN_OFF_DUE_HOUR = 14;
